import {
  Avatar,
  Badge,
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
// import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
// import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
// import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import {
  HomeOutlined as HomeIcon,
  HubOutlined as HubIcon,
  BusinessCenterOutlined as BusinessCenterIcon,
  TextsmsOutlined as TextsmsIcon,
  NotificationsNoneOutlined as NotificationsIcon,
  Image,
  AccountBalanceWalletOutlined,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import AccountDropDownMenu from "./AccountDropDownMenu";
import api from "../config/axios";
const navBarButtons = [
  {
    text: "Home",
    icon: "/icons/homeIcon.svg",
    badge: false,
    link: "home/app-home",
  },
  {
    text: "Network",
    icon: "/icons/networkIcon.svg",
    badge: true,
    link: "home/network",
  },
  { text: "Jobs", icon: "/icons/jobsIcon.svg", badge: true, link: "home/jobs" },
  {
    text: "Messages",
    icon: "/icons/messagesIcon.svg",
    badge: false,
    link: "home/messages",
  },
  {
    text: "Notifications",
    icon: "/icons/notificationsIcon.svg",
    badge: true,
    link: "home/notifications",
  },
];
function    AppNavBar() {
  const navigate = useNavigate();
  const notificationCount = ""; // Empty means show a red dot
  const [activeIndux, setActiveIndex] = useState(0);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    // Fetch current user data
    api
      .get("/auth/me")
      .then((res) => {
        setProfile(res.data);
      })
      .catch((err) => {
        console.error("Error fetching user data:", err);
      });
  }, []);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      gap={3.5}
      sx={{
        // width: "100%",
        // maxWidth: "75%",
        bgcolor: "#ffffff",
        p: "20px",
      }}
    >
      <Box>
        <Typography
          variant="h6"
          sx={{ color: "#161616", fontSize: "20px", lineHeight: "16px" }}
        >
          Hello, {profile ? `${profile.firstName} ${profile.lastName}` : "Guest"}
        </Typography>
        <Typography variant="body2" sx={{ color: "#8c8c8c", pt: "6px" }}>
          Welcome back, let's explore now!
        </Typography>
      </Box>

      <Stack
        direction="row"
        gap={2}
        sx={{
          bgcolor: "#f9f9f9",
          px: "16px",
          borderRadius: "12px",
          alignItems: "center",
          py: "4px",
        }}
      >
        {navBarButtons.map((button, i) => {
          const isActive = i === activeIndux;
          return button.badge ? (
            <NavLink to={button.link}>
              <Button
                key={i}
                variant="text"
                sx={{
                  color: "#000000",
                  fontSize: "12px",
                  textTransform: "none",
                  gap: 0,
                  border: isActive ? "2px solid #e3e3e3" : "none",
                  "& .MuiButton-startIcon": {
                    marginRight: "6px",
                  },
                  bgcolor: isActive ? "#ffffff" : "none",
                  borderRadius: "8px",
                  py: isActive ? "4px" : "0px",
                  px: "10px",
                }}
                onClick={() => setActiveIndex(i)}
                startIcon={
                  <Box
                    component="img"
                    src={button.icon}
                    sx={{ width: "14px", height: "14px" }}
                  ></Box>
                }
              >
                <Badge
                  badgeContent={notificationCount || undefined} // Show number if available
                  variant={notificationCount ? "standard" : "dot"} // Red dot if empty
                  sx={{
                    "& .MuiBadge-badge": {
                      position: "absolute",
                      right: -3,
                      top: 6,
                      backgroundColor: "#ff0000",
                      fontSize: notificationCount ? "0.7rem" : "auto", // Adjust size if number
                      minWidth: notificationCount ? "16px" : "6px", // Dot size adjustment
                      height: notificationCount ? "16px" : "6px", // Dot size adjustment
                    },
                  }}
                >
                  {button.text}
                </Badge>
              </Button>
            </NavLink>
          ) : (
            <NavLink to={button.link}>
              <Button
                variant="text"
                startIcon={
                  <Box
                    component="img"
                    src={button.icon}
                    sx={{ width: "14px", height: "14px" }}
                  ></Box>
                }
                onClick={() => setActiveIndex(i)}
                sx={{
                  fontSize: "12px",
                  color: "#000000",
                  textTransform: "none",
                  "& .MuiButton-startIcon": {
                    marginRight: "6px", // Removes default margin
                  },
                  border: isActive ? "2px solid #e3e3e3" : "none",
                  bgcolor: isActive ? "#ffffff" : "none",
                  borderRadius: "8px",
                  py: "0px",
                  px: "10px",
                  py: isActive ? "4px" : "0px",
                }}
              >
                {button.text}
              </Button>
            </NavLink>
          );
        })}
      </Stack>
      <Stack
        id="Setting-avatar"
        direction="row"
        gap={1}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Avatar
          component="button"
          sx={{
            bgcolor: "#FFFFFF",
            border: "1px solid #d4d4d4",
            mr: "6px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/settings")}
        >
          {/* <SettingsOutlinedIcon sx={{ color: "#111111" }} /> */}
          <Box component="img" src="/icons/settingIcon.svg"></Box>
        </Avatar>

        <Typography variant="subtitle2" sx={{ color: "#000000" }}>
          {profile ? `${profile.firstName} ${profile.lastName}` : "Guest"}
        </Typography>

        <AccountDropDownMenu />
      </Stack>
    </Stack>
  );
}

export default AppNavBar;
{
  /* <Button
          variant="text"
          startIcon={<HomeOutlinedIcon />}
          sx={{
            color: "#000000",
            textTransform: "none",

            "& .MuiButton-startIcon": {
              marginRight: "5px", // Removes default margin
            },
          }}
        >
          Home
        </Button>

        <Button
          variant="text"
          sx={{
            color: "#000000",
            textTransform: "none",
            gap: 0,
            "& .MuiButton-startIcon": {
              marginRight: "5px",
            },
          }}
          startIcon={<HubOutlinedIcon />}
        >
          <Badge
            badgeContent={notificationCount || undefined} // Show number if available
            variant={notificationCount ? "standard" : "dot"} // Red dot if empty
            sx={{
              "& .MuiBadge-badge": {
                position: "absolute",
                right: -3,
                top: 6,
                backgroundColor: "#ff0000",
                fontSize: notificationCount ? "0.7rem" : "auto", // Adjust size if number
                minWidth: notificationCount ? "16px" : "6px", // Dot size adjustment
                height: notificationCount ? "16px" : "6px", // Dot size adjustment
              },
            }}
          >
            Network
          </Badge>
        </Button>
        <Button
          variant="text"
          sx={{
            color: "#000000",
            textTransform: "none",
            gap: 0,
            "& .MuiButton-startIcon": {
              marginRight: "5px",
            },
          }}
          startIcon={<BusinessCenterOutlinedIcon />}
        >
          <Badge
            badgeContent={notificationCount || undefined} // Show number if available
            variant={notificationCount ? "standard" : "dot"} // Red dot if empty
            sx={{
              "& .MuiBadge-badge": {
                position: "absolute",
                right: -3,
                top: 6,
                backgroundColor: "#ff0000",
                fontSize: notificationCount ? "0.7rem" : "auto", // Adjust size if number
                minWidth: notificationCount ? "16px" : "6px", // Dot size adjustment
                height: notificationCount ? "16px" : "6px", // Dot size adjustment
              },
            }}
          >
            Jobs
          </Badge>
        </Button>
        <Button
          variant="text"
          startIcon={<TextsmsOutlinedIcon />}
          sx={{
            color: "#000000",
            textTransform: "none",

            "& .MuiButton-startIcon": {
              marginRight: "5px", // Removes default margin
            },
          }}
        >
          Messages
        </Button> */
}

